<!-- RADIO-GROUP -->
@if (!summary) {
  <mat-radio-group class="d-flex flex-column"
    [(ngModel)]="questionModel"
    (change)="onModelChange()"
    [formControl]="control">
    @for (question of questions; track question) {
      <mat-radio-button [value]="question.questionNumber">
        <span class="font-weight-bold" [innerHtml]="question.editLabel | localized"></span>
      </mat-radio-button>
    }
  </mat-radio-group>
}
@if (!control?.valid && control?.touched) {
  <mat-error>
    {{'form.validation.required' | translate}}
  </mat-error>
}
<!-- SUMMARY -->
@if (summary) {
  <div
    class="mb-2">
    <span class="font-weight-bold">
      <mat-icon>checked</mat-icon> {{ getSummaryLabel() | localized}}
    </span>
  </div>
}
